@if (isMenu) {
  <button mat-menu-item>
    <mat-icon>verified_outline</mat-icon>
    {{ 'audit' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    aria-label="Audit"
    matTooltip="{{ 'audit' | translate }}">
    <mat-icon>verified_outline</mat-icon>
  </button>
}
